import tr from './assets/i18n/tr.json';
import en from './assets/i18n/en.json';
import pt from './assets/i18n/pt.json';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export default new VueI18n({
  locale: localStorage.getItem('lang') || 'tr',
  strategy: 'prefix_except_default',
  messages: {
    tr: tr,
    en: en,
    pt: pt,
  },
});
